import React from "react";

import classNames from "classnames";

// material-ui
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

// core components
import { container } from "assets/jss/material-kit-pro-react.jsx";

import { appUrl } from "../../../../config";

const useStyles = makeStyles({
  container,
  marginTop: {
    marginTop: "180px",
  },
  title: {
    margin: "80px 0",
  },
  textCenter: {
    textAlign: "center",
  },
  flowContainer: {
    // padding: "60px 0",
  },
});

const DataFlow = () => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, classes.marginTop)}>
      <div className={classes.title}>
        <Typography className={classes.textCenter} variant="h3">
          Data Flow
        </Typography>
      </div>

      <div className={classes.flowContainer}>
        <img style={{ width: "100%" }} src={`${appUrl}/media/optafloor/data-flow.jpeg`} alt="Data Flow" />
      </div>
    </div>
  );
};

export default DataFlow;
